<template>
  <c-container padding-size="small">
    <c-flex-layout>
      <template #left>
        <h2>Workspaces</h2>
      </template>
      <template #right>
        <c-button
          icon="plus"
          fab
          :href="connectToNotionUrl"
          target="_blank"
        />
      </template>
    </c-flex-layout>
    <c-list>
      <c-card-item
        v-for="(workspace, idx) in workspaces"
        :key="idx"
        show-as-card
        :title="workspace.name"
        size="large"
        @click="selectWorkspace(workspace)"
      >
        <template #right>
          <c-dropdown @click.stop>
            <c-button
              fab
              icon="more"
              color="light"
            />
            <template #content>
              <c-card contains-list>
                <c-card-item
                  icon="edit"
                  title="Edit"
                  :href="connectToNotionUrl"
                  target="_blank"
                />
                <c-card-item
                  icon="delete"
                  title="Delete"
                  @click="workspaceService.deleteWorkspace(workspace)"
                />
              </c-card>
            </template>
          </c-dropdown>
        </template>
      </c-card-item>
      <c-button
        icon="plus"
        stretch
        color="light"
        :style="{ justifyContent: 'flex-start' }"
        :href="connectToNotionUrl"
        target="_blank"
      >
        Add workspace
      </c-button>
    </c-list>
  </c-container>
</template>

<script>
import CButton from 'shared/components/CButton.vue';
import CCard from 'shared/components/CCard.vue';
import CCardItem from 'shared/components/CCardItem.vue';
import CContainer from 'shared/components/CContainer.vue';
import CDropdown from 'shared/components/CDropdown.vue';
import CFlexLayout from 'shared/components/CFlexLayout.vue';
import CList from 'shared/components/CList.vue';
import { USER_SERVICE, WORKSPACE_SERVICE } from 'shared/constants';
import { inject } from 'vue';

export default {
  name: 'SeeWorkspaces',
  setup() {
    const { currentUser } = inject(USER_SERVICE);
    const workspaceService = inject(WORKSPACE_SERVICE);
    return { currentUser, workspaces: workspaceService.getAll(), workspaceService };
  },
  components: {
    CCard,
    CContainer,
    CButton,
    CFlexLayout,
    CCardItem,
    CDropdown,
    CList,
  },
  data() {
    return { connectLoading: false, connectToNotionUrl: `${import.meta.env.VITE_WEBSITE_URL}/app/connect-to-notion` };
  },
  emits: ['see-templates'],
  methods: {
    selectWorkspace(workspace) {
      this.workspaceService.saveLastSelectedWorkspace(workspace);
      this.$emit('see-templates', workspace.id);
    },
  },
};
</script>

<style scoped type="text/scss">
</style>
